import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { notFoundRoute, redirects, routes } from './routes';
import { RedirectRoute } from './components/RedirectRoute';
import { RouteMeta } from './components/RouteMeta';
import { ScrollToTop } from './components/ScrollToTop';
import { SiteFooter } from './components/SiteFooter';
import { AuthProvider } from './lib/auth/AuthContext';

export default function App() {
  return (
    <AuthProvider>
      <div className="bg-page-texture relative isolate flex min-h-screen flex-col overflow-hidden text-brand-white">
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-brand-red focus:px-4 focus:py-2 focus:font-heading focus:uppercase focus:tracking-wider focus:text-white"
        >
          Skip to main content
        </a>
        <RouteMeta />
        <ScrollToTop />
        <main id="main" tabIndex={-1} className="relative flex flex-1 flex-col">
          {/* Lazy-route fallback is intentionally empty: the page texture +
              black shell already read as the site's loading state, and the
              chunks are small enough that a spinner would only flash. */}
          <Suspense fallback={null}>
            <Routes>
              {routes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
              ))}
              {redirects.map(({ from, to }) => (
                <Route key={from} path={from} element={<RedirectRoute to={to} />} />
              ))}
              <Route path={notFoundRoute.path} element={<notFoundRoute.Component />} />
            </Routes>
          </Suspense>
        </main>
        <SiteFooter />
      </div>
    </AuthProvider>
  );
}
